<template>
    <v-container align="center">
        <v-row>
            <v-col cols=12>
                
                <v-card align="center" flat>
                    <form @submit.prevent="validateLoginForm">
                       
                        
                            <v-col cols="12" md="6">
                                <v-text-field type="text" name="federation_acct"
                                    v-model="authinfo.federation_acct"
                                    placeholder="E-Mail"
                                    label="E-Mail"
                                    :error-messages="$v.authinfo.federation_acct.$error ? 'Este campo es requerido' : ''"
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-btn
                                    @click.prevent="send_mail">Reestablecer Contraseña</v-btn>
                            </v-col>
                            <v-dialog
                                                v-model="dialog"
                                                persistent
                                                width="300"
                                            >
                                                <v-card
                                                color="primary"
                                                dark
                                                >
                                                <v-card-text>
                                                    Por favor espere
                                                    <v-progress-linear
                                                    indeterminate
                                                    color="white"
                                                    class="mb-0"
                                                    ></v-progress-linear>
                                                </v-card-text>
                                                </v-card>
                            </v-dialog>
                        
                    </form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>  
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { forgotPassword } from '@/services/monolito';

export default {
    name: 'forgot',
    mixins: [validationMixin],
    data() {
        return {
            authinfo: {
                federation_acct: "",
            },
            dialog : false,
            stderr: []
        }
    },
    validations() {
        return {
            authinfo: {
                federation_acct: { required, minLength: minLength(9), maxLength: maxLength(37) }
            }
        }
    },
    computed: {
        // Check that the server field is not empty
        IsEmpty () {
        const empty = this.authinfo.federation_acct.length == 0
        return empty ? true : false
        }
    },

    methods: {
        async validateLoginForm() {
            const result = await this.$v.$validate()
            if (!result) {
                return
            }
            await this.send_mail()
        },
        set_dialog(state){
            this.dialog = state
        },
        set_sendmail () {
                // redirect to the "Workplace" component
                this.$router.replace({ name: "home" });
            },

        /* Connects to the Thalamus server */
        async send_mail () {
            this.dialog = true
            try {
                await forgotPassword(this.authinfo.federation_acct);
                await this.$alert({
                  title: 'Correo enviado',
                  message: 'Se ha enviado un mail para reestablecer la contraseña. Por favor revise su bandeja de entrada.',
                  color: 'success'
                })
                this.set_sendmail();
            } catch (error) {
                if (error.response && error.response.status === 423) {
                    await this.$alert({ title: 'No encontrado', message: 'Este mail no se encuentra en nuestra base de datos.', color: 'error' })
                } else {
                    await this.$alert({ title: 'Usuario inexistente', message: 'Este usuario no se encuentra en nuestra base de datos.', color: 'error' })
                }
            }
            this.set_dialog(false);
        },
    }
}
</script>